// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"355":"1e6c52b017362d7366f3","494":"4bb7a8164b732892497d"}[chunkId] + ".js";
};